import React, { useContext } from "react";
import Answer from "../Answer";
import TopicTools from "../TopicTools";
import className from "classnames";
import styles from "./index.module.scss";
import { DiscussContent } from "../../context";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { Button } from "antd";

export default function AnswerList() {
    const { discussDetail, setIsWriting } = useContext(DiscussContent);

    return (
        <div className={className("container", styles.root)}>
            <TopicTools />

            {discussDetail?.replies?.map((item, index) => (
                <Answer key={item.uuid} index={index} data={item} />
            ))}

            {!discussDetail?.replies?.length && (
                <CustomEmpty
                    className={styles.empty}
                    description={
                        <Button
                            type="primary"
                            onClick={() => setIsWriting(true)}>
                            我来回答
                        </Button>
                    }
                />
            )}
        </div>
    );
}
